var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        {
          staticClass: "full-card-desktop py-0 px-0",
          attrs: { expand: "", flat: "" }
        },
        [
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "v-tab-item",
                { attrs: { value: "connect", lazy: "" } },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "darken-1",
                      attrs: { flat: "", color: "white" }
                    },
                    [
                      !_vm.hasCurrentCredential
                        ? _c("v-icon", { attrs: { color: "red" } }, [
                            _vm._v("\n              report\n            ")
                          ])
                        : _c("v-icon", { attrs: { color: _vm.xBlue } }, [
                            _vm._v("offline_bolt")
                          ]),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v("Xero Direct")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", flat: "", color: "accent" },
                              on: { click: _vm.refreshXeroTenantInfo }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("download")]),
                                  _vm._v(
                                    "\n                  Refresh\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.hasCurrentCredential ||
                  _vm.daysUntilXeroCredentialsExpire(_vm.company) < 8
                    ? [
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              value: !_vm.hasCurrentCredential,
                              type: "error"
                            }
                          },
                          [_c("strong", [_vm._v("Requires Authentication")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              type: "warning",
                              value:
                                _vm.hasCurrentCredential &&
                                _vm.daysUntilXeroCredentialsExpire(
                                  _vm.company
                                ) < 8
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                "Credentials expire in " +
                                  _vm._s(
                                    _vm.daysUntilXeroCredentialsExpire(
                                      _vm.company
                                    )
                                  ) +
                                  " days"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pa-2" }, [
                          _c("p", [
                            _vm._v(
                              "For your security, Xero requires that you provide Xero credentials at\n                least every 60 days."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Click below to continue allowing " +
                                _vm._s(_vm.$t("site-title.brief")) +
                                " to communicate with your\n                Xero tenant."
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { "two-lines": "" } },
                    [
                      _c(
                        "v-subheader",
                        [
                          _c("v-icon", { staticClass: "pr-2" }, [
                            _vm._v("settings")
                          ]),
                          _vm._v(
                            "\n              Xero Company Profile\n            "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                  business\n                "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm._.get(_vm.xeroDirect, "companyName")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm._.get(
                                      _vm.xeroDirect,
                                      "companyLegalName"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                  repeat\n                "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _c("code", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._.get(
                                        _vm.xeroDirect,
                                        "subscriptionPlan",
                                        "Unknown"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" Subscription Plan")
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _vm._v(
                                  _vm._s(_vm.xeroSubscriptionRequiredForBilling)
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.configuredToCollectTax
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [
                                      _vm._v(
                                        "\n                  account_balance\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Default Tax Codes Applied")
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "to invoice and bill transactions. Can be modified per load if necessary."
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-subheader",
                        [
                          _c("v-icon", { staticClass: "pr-2" }, [
                            _vm._v("fingerprint")
                          ]),
                          _vm._v("\n              Authorization\n            ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(
                                  "\n                  person_outline\n                "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._.get(
                                        _vm.xeroDirect,
                                        "authenticatedBy"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        _vm._.get(
                                          _vm.xeroDirect,
                                          "authenticated"
                                        )
                                      )
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("event")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDay")(
                                      _vm._.get(
                                        _vm.xeroDirect,
                                        "credentialExpires"
                                      )
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v(
                                    "Must re-authorize " +
                                      _vm._s(_vm.$t("site-title.brief")) +
                                      " on or before"
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasOfficePermission
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("autorenew")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                  Authorize " +
                                        _vm._s(_vm.$t("site-title.brief")) +
                                        "\n                "
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-xero-direct-connect-btn", {
                                attrs: {
                                  "company-id": _vm.company.id,
                                  connecting: _vm.loadingBtn
                                },
                                on: {
                                  connecting: function($event) {
                                    _vm.loadingBtn = true
                                  },
                                  connected: _vm.xeroConnected
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasOfficePermission && _vm.isConnected
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c("v-icon", { attrs: { color: "red" } }, [
                                    _vm._v("clear")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                  Revoke Permission\n                "
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pl-0 pr-0 mr-2",
                                  attrs: { flat: "", color: "red" },
                                  on: { click: _vm.disconnectTenant }
                                },
                                [
                                  _c("v-icon", { staticClass: "pr-2" }, [
                                    _vm._v("cancel")
                                  ]),
                                  _vm._v(
                                    "\n                Revoke\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "defaults", lazy: "" } },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "darken-1",
                      attrs: { flat: "", color: "white" }
                    },
                    [
                      _c("v-xero-icon"),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v("Xero Export Defaults")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", flat: "", color: "accent" },
                              on: { click: _vm.showExportDefaultsDialog }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("edit")]),
                                  _vm._v(
                                    "\n                  Edit\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", flat: "", color: "accent" },
                              on: { click: _vm.reloadCompanyXeroData }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("refresh")]),
                                  _vm._v(
                                    "\n                  Reload\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-bottom-nav",
        {
          attrs: { active: _vm.activeTab, value: true },
          on: {
            "update:active": function($event) {
              _vm.activeTab = $event
            }
          }
        },
        [
          _c(
            "v-btn",
            { attrs: { flat: "", color: "accent", value: "connect" } },
            [
              _vm._v("\n            Connect\n            "),
              _c("v-icon", { attrs: { color: _vm.xBlue } }, [
                _vm._v("offline_bolt")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                flat: "",
                color: "accent",
                value: "defaults",
                disabled: !_vm.isConnected
              }
            },
            [
              _vm._v("\n            Export Defaults\n            "),
              _c("V-icon", { attrs: { color: _vm.xBlue } }, [
                _vm._v("import_export")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                flat: "",
                color: "accent",
                value: "customers",
                disabled: !_vm.isConnected
              }
            },
            [
              _vm._v("\n            Customers\n            "),
              _c("v-icon", { attrs: { color: _vm.xBlue } }, [_vm._v("face")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                flat: "",
                color: "accent",
                value: "qb_vendors",
                disabled: !_vm.isConnected
              }
            },
            [
              _vm._v("\n            Vendors\n            "),
              _c("v-icon", { attrs: { color: _vm.xBlue } }, [_vm._v("share")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bf8bf92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf8bf92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/XeroSection.vue
// module id = null
// module chunks = 